var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex is-justify-content-center is align-items-center",attrs:{"id":"loading"}},[_c('img',{attrs:{"src":require('@/assets/ball-triangle.svg'),"alt":"Se încarcă..."}})])
}
var staticRenderFns = []

export { render, staticRenderFns }